import { gsap, ScrollTrigger } from 'gsap/all';

export default class CardStack {
  constructor(element) {
    this.element = element;
    this.cards = element.querySelectorAll('.card');
    this.animations = [];
    this.update = this.update.bind(this);

    gsap.registerPlugin(ScrollTrigger);

    window.addEventListener('resize', this.update);

    this.initialize();
  }

  initialize() {
    this.update();
  }

  update() {
    const _this = this;
    this.destroy();

    // loop through all cards
    this.cards.forEach((card, i) => {
      const card_height = card.offsetHeight;
      const card_top = card.offsetTop - this.element.offsetTop;
      const card_end = card_top + card_height;
      const card_offset = 500;

      const content = card.querySelector('.content');
      const background = card.querySelector('.background');
      const background_offset = 1000;

      // scaling + movement
      this.animations.push(
        gsap.to(content, {
          scrollTrigger: {
            trigger: card,
            start: `-100px top`,
            end: `${card_height + card_offset} top`,
            scrub: true,
            // markers: true,
          },
          scale: 0.8,
          translateY: '-20%',
          ease: 'quad.out', // ease out
        })
      );
    });
  }

  destroy() {
    // remove all old animations
    this.animations.forEach((animation) => animation.kill());
    this.animations = [];
  }
}
